export default class {
    constructor ($translate) {
        this.$translate = $translate;
    }

    isAddedToOccurrence (application, showBoolean = true) {
        const translationYes = showBoolean ? this.$translate.instant('general.Yes') : this.$translate.instant('application.Added to occurrence');
        const translationNo = showBoolean ? this.$translate.instant('general.No') : this.$translate.instant('application.Not added to occurrence');

        return (application.occurrence.courseOccurrenceParticipants.length
            && application.occurrence.courseOccurrenceParticipants.find((participant) => parseInt(participant.userId, 10) === parseInt(application.employeeId, 10)))
            ? translationYes
            : translationNo;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/application/index.js